<template>
  <div>
    <HeroSmall />
    <b-container class="mt-5 mb-5">
      <h1 class="display-1">{{ this.$route.params.city }}</h1>
    </b-container>
    <Blogs :tag="this.$route.params.city" />
  </div>
</template>

<script>
import HeroSmall from '@/components/ui/HeroSmall.vue'
import Blogs from '@/components/ui/Blogs.vue'

export default {
  name: 'City',
  components: {
    HeroSmall,
    Blogs,
  },
}
</script>

<style scoped>

</style>